<template>
    <div class="m-3">
        <h2 class="font-bold mb-3">Код відправлено на вказаний email</h2>
    </div>
</template>
